<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="saveBtn"><el-button type="primary" @click="submit">保存配置</el-button></div>
      <div class="skt" ref="skt">
        <el-tabs v-model="activeName1" style="background-color: #ffffff;padding: 30px 30px 0 30px;">
            <el-tab-pane label="新产生预警" name="1">
                <el-form ref="form" :model="form1" label-width="80px">
                    <el-form-item label="">
                        <el-checkbox-group v-model="form1.type">
                        <el-checkbox
                          v-for="item in group"
                          :key="item.groupId"
                          :label="item.groupId"
                          name="type">
                          {{item.groupName}}
                        </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2" style="background-color: #ffffff;padding: 0 30px;">
            <el-tab-pane label="内部预警" name="2">
                <el-form ref="form" :model="form2" label-width="80px">
                    <el-form-item label="">
                        <el-checkbox-group v-model="form2.type">
                        <el-checkbox
                          v-for="item in group"
                          :key="item.groupId"
                          :label="item.groupId"
                          name="type">
                          {{item.groupName}}
                        </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName3" style="background-color: #ffffff;padding: 0 30px;">
            <el-tab-pane label="外部预警" name="3">
                <el-form ref="form" :model="form3" label-width="80px">
                    <el-form-item label="">
                        <el-checkbox-group v-model="form3.type">
                        <el-checkbox
                          v-for="item in group"
                          :key="item.groupId"
                          :label="item.groupId"
                          name="type">
                          {{item.groupName}}
                        </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName4" style="background-color: #ffffff;padding: 0 30px 30px 30px;">
            <el-tab-pane label="响应启动" name="4">
                  <el-form ref="form" :model="form4" label-width="80px">
                    <el-form-item label="">
                        <el-checkbox-group v-model="form4.type">
                        <el-checkbox
                          v-for="item in group"
                          :key="item.groupId"
                          :label="item.groupId"
                          name="type">
                          {{item.groupName}}
                        </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
  </div>
</template>
<script>
import warnTypes from '@/store/types/warningcenter'
export default {
  name: 'groupRelations',
  data () {
    return {
      group: [],
      activeName1: '1',
      activeName2: '2',
      activeName3: '3',
      activeName4: '4',
      form1: {
        type: []
      },
      form2: {
        type: []
      },
      form3: {
        type: []
      },
      form4: {
        type: []
      }
    }
  },
  methods: {
    // 群组列表
    grouplist () {
      this.$store.dispatch(warnTypes.GET_GROUPLIST).then(data => {
        this.group = data
      })
    },
    // 群组保存信息
    getrelation1 () {
      this.$store.dispatch(warnTypes.GET_PERSONGROUPRELATION, { relationName: '新产生预警' }).then(data => {
        this.form1.type = data.results.map(x => String(x))
      })
    },
    getrelation2 () {
      this.$store.dispatch(warnTypes.GET_PERSONGROUPRELATION, { relationName: '内部预警' }).then(data => {
        this.form2.type = data.results.map(x => String(x))
      })
    },
    getrelation3 () {
      this.$store.dispatch(warnTypes.GET_PERSONGROUPRELATION, { relationName: '外部预警' }).then(data => {
        this.form3.type = data.results.map(x => String(x))
      })
    },
    getrelation4 () {
      this.$store.dispatch(warnTypes.GET_PERSONGROUPRELATION, { relationName: '响应启动' }).then(data => {
        this.form4.type = data.results.map(x => String(x))
      })
    },
    // 保存新增/编辑
    submit () {
      let groupList = [{
        GroupId: this.form1.type.join(','),
        RelationName: '新产生预警'
      }, {
        GroupId: this.form2.type.join(','),
        RelationName: '内部预警'
      }, {
        GroupId: this.form3.type.join(','),
        RelationName: '外部预警'
      }, {
        GroupId: this.form4.type.join(','),
        RelationName: '响应启动'
      }]
      this.$store.dispatch(warnTypes.SAVE_PERSONGROUPRELATION, { GroupList: groupList }).then(() => {
        this.$notify.success({ title: '成功', message: '保存成功。', offset: 100 })
        this.getrelation1()
        this.getrelation2()
        this.getrelation3()
        this.getrelation4()
      })
    }
  },
  mounted () {
    this.grouplist()
    this.getrelation1()
    this.getrelation2()
    this.getrelation3()
    this.getrelation4()
  }
}
</script>
<style lang="less" src="@/assets/warningcenter.less" scoped></style>
<style scoped lang="less">
body{
  background-color: #f0f2f6;
  margin: 0;
  padding: 0 0 10px 0;
}
.el-checkbox {
  width: 150px;
  margin-left: 50px;
}
.content{
  position: relative;
  .saveBtn{
    position: absolute;
    top: 30px;
    right: 60px;
    z-index: 1999;
  }
}
.skt {
  margin-top: 0Px !important;
  height: 100%;
  overflow-y: auto;
}
</style>
